import { VIDEOS, GET_VIDEOS, setVideos } from "./../actions/videosActions";
import { setLoader } from "./../actions/uiActions";
import { setNotification } from "./../actions/notificationActions";
import { takeLatest, put, call } from "redux-saga/effects";
import { db } from "./../../firebase";

function* getVideos(action) {
  try {
    yield put(setLoader({ state: true, resource: VIDEOS }));
    const ref = db.ref();
    const snap = yield call([ref, ref.once], "value");
    const val = snap.val();
    const value = val ? val["videos"] : [];
    yield put(setVideos(value));
    yield put(setLoader({ state: false, resource: VIDEOS }));
  } catch (error) {
    yield put(setLoader({ state: false, resource: VIDEOS }));
    yield put(setNotification({ message: error.message, resource: VIDEOS }));
  }
}

export default function* videoWatcher() {
  yield takeLatest(GET_VIDEOS, getVideos);
}



// WEBPACK FOOTER //
// ./src/redux/middleware/videosMiddlerware.js